// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__10nn5"};